import React, { useContext, useEffect, useState } from "react";
import { LAText, LATextInput, LAView } from "../../components";
import { SVG_IMAGES } from "../../assets";
import CollapseItem from "../../components/CollapseItem";
import CollapseSubItem from "../../components/CollapseSubItem";
import { GET_STUDY_QUESTION_MENU } from "../../../app_constant";
import { BundleContext } from "../../context/BundleProvider";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthProvider";
import { ThemeContext } from "../../context/ThemeProvider";
import _ from "lodash";
import { MixpanelContext } from "../../context/MixpanelProvider";
import BookMarkPopup from "../quickSet/BookMarkPopup";
import { STRING, STRINGS } from "../../constant";
import BackArrowIcon from "../../components/BackArrowIcon";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookmark,
  faBook,
  faLayerGroup,
  faGraduationCap,
  faList,
  faChevronUp,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { getThemeTextColor } from "../../utils/themeUtils";
import InfoPopup from "../quickSet/InfoPopup";
import { createLogger } from "../../utils/logger";

const StudyQuestion = () => {
  const [openItemId, setOpenItemId] = useState(2);
  const [subOpenItemId, setSubOpenItemId] = useState(null);
  const { selectedCertificate } = useContext(BundleContext);
  const { questionsList, profile, loggingEnabled } = useContext(AuthContext);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedMainMenu, setSelectedMainMenu] = useState(null);
  const [selectedTopicBookmark, setSelectedTopicBookmark] = useState(null);
  const [selectedBookmarkTopic, setSelectedBookmarkTopic] = useState(null);
  const [isProgressProgressBookmark, setProgressBookmark] = useState(false);
  const [isProgressQuestion, setProgressQuestion] = useState(false);
  const { theme, currentTheme } = useContext(ThemeContext);
  const { trackReadinessScore, trackQuestionBookmark, trackStudyQuestions } =
    useContext(MixpanelContext);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const logger = createLogger(loggingEnabled, 'StudyQuestion');
  let STUDY_QUESTION_MENU = GET_STUDY_QUESTION_MENU(selectedCertificate);

  const selectedItems = [];

  const selectedIndex = (STUDY_QUESTION_MENU ?? []).findIndex(
    (e) => e.key == "by_topic"
  );
  selectedIndex >= 0 &&
    selectedItems.push(STUDY_QUESTION_MENU[selectedIndex].title);

  const selectedFreeIndex = (STUDY_QUESTION_MENU ?? []).findIndex(
    (e) => e.key == "by_topic_free_model"
  );
  selectedFreeIndex >= 0 &&
    selectedItems.push(STUDY_QUESTION_MENU[selectedFreeIndex].title);

  const [selectedMenu, setSelectedMenu] = useState(
    selectedIndex >= 0 ? selectedItems : []
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (selectedTopic) {
      setProgressQuestion(true);
    }
  }, [selectedTopic]);

  useEffect(() => {
    if (selectedTopicBookmark) {
      setProgressBookmark(true);
    }
  }, [selectedTopicBookmark]);

  function getQuestionCount(ele, item) {
    let questions = [];
    if (ele.key === "bookmark") {
      const array = profile?.question_bookmarks ?? [];
      if (item.domain_name === "All Bookmarks") {
        questions = questionsList?.filter((e) => array.includes(e.id));
      } else {
        questions = questionsList?.filter((e) => array.includes(e.id)).filter((e) => e?.topic_id == item?.id);
      }
    }
    else {
      questions = questionsList?.filter((e) => e?.topic_id == item?.id);
    }
    return questions.length;
  }

  function onPressTopic(item, ele) {


    trackStudyQuestions("By Topic");
    logger.log('[StudyQuestion] Profile:', profile);

    const progress = profile.questions_progress ?? [];
    logger.log('[StudyQuestion] Progress:', progress);
    const setProgress = progress.filter((obj) => {
      return obj.study_questions_set_id == item.id + 2;
    });

    const questions = questionsList?.filter((e) => e.topic_id == item.id);

    if (
      setProgress &&
      setProgress.length > 0 &&
      questions[0]?.id != setProgress[0]?.last_seen_question_id
    ) {
      setSelectedTopic(item);
      setSelectedMainMenu(ele);
    } else {
      if (ele.free_model == 1) {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: item?.id + 2,
            source: "study_menu",
            questions: questions.slice(0, item.num_questions),
          },
        });
      } else {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: item?.id + 2,
            source: "study_menu",
            questions: questions,
          },
        });
      }
    }
  }

  function onPressBookmarkTopic(subElement, ele) {
    const array = profile?.question_bookmarks ?? []
    const questions = questionsList.filter((e) => array.includes(e.id))

    const topic_questions = (subElement.domain_name === "All Bookmarks")
      ? questions
      : questions.filter((e) => e.topic_id === subElement.id);
    const bookmark_id = (subElement.domain_name === "All Bookmarks") ? "bookmark" : "bookmark_" + subElement.id

    if (topic_questions?.length > 0) {
      const progress = profile.questions_progress ?? []
      const setProgress = progress.filter((obj) => {
        return obj.study_questions_set_id == bookmark_id
      })

      if (setProgress && setProgress.length > 0 && topic_questions.length > 0 && topic_questions[0].id != setProgress[0].last_seen_question_id) {
        setSelectedTopicBookmark(ele)
        setSelectedBookmarkTopic(subElement)
      }
      else {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: bookmark_id,
            source: "study_menu",
            questions: topic_questions,
          },
        });
      }
    }
  }

  function onPressItem(item, index) {
    if (index == 0) {
      trackStudyQuestions("Bookmarks");

      const progress = profile.questions_progress ?? [];
      const setProgress = progress.filter((obj) => {
        return obj.study_questions_set_id == "bookmark";
      });

      const array = profile?.question_bookmarks ?? [];
      const questions = questionsList?.filter((e) => array.includes(e.id));
      if (
        setProgress &&
        setProgress.length > 0 &&
        questions.length > 0 &&
        questions[0]?.id != setProgress[0].last_seen_question_id
      ) {
        setSelectedTopicBookmark(item);
      } else {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: "bookmark",
            questions: questions,
          },
        });
      }
    } else if (index == 1) {
      trackStudyQuestions("Quick Set");
      let questions = _.shuffle(questionsList);
      questions = questions.slice(0, 10);

      navigate(`/studyquestions/question`, {
        state: {
          title: item.title,
          questions: questions,
        },
      });
    }
  }

  function onActionBookmark(index) {
    const item = selectedBookmarkTopic;
    const array = profile?.question_bookmarks ?? [];
    const questions = questionsList?.filter((e) => array.includes(e.id));
    const topic_questions = (item.domain_name === "All Bookmarks")
      ? questions
      : questions.filter((e) => e.topic_id === item.id);
    const bookmark_id = (item.domain_name === "All Bookmarks") ? "bookmark" : "bookmark_" + item.id

    if (index == 0) {
      navigate(`/studyquestions/question`, {
        state: {
          set_id: bookmark_id,
          questions: topic_questions,
        },
      });
    } else if (index == 1) {
      const progress = profile.questions_progress;
      const setProgress = progress.filter(
        (obj) => obj.study_questions_set_id == bookmark_id
      );

      if (setProgress.length > 0) {
        const index = topic_questions.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_question_id
        );
        navigate(`/studyquestions/question`, {
          state: {
            set_id: bookmark_id,
            questions: topic_questions,
            lastIndex: index == -1 ? 0 : index,
          },
        });
      }
    }
  }

  function onAction(index) {
    const item = selectedTopic;
    const menu = selectedMainMenu;

    if (index == 0) {
      const questions = questionsList?.filter((e) => e.topic_id == item.id);
      if (menu.free_model == 1) {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: item.id + 2,
            questions: questions.slice(0, item?.num_questions),
            free_model: 1,
          },
        });
      } else {
        navigate(`/studyquestions/question`, {
          state: {
            set_id: item.id + 2,
            questions: questions,
          },
        });
      }
    } else if (index == 1) {
      const progress = profile.questions_progress;
      const setProgress = progress.filter(
        (obj) => obj.study_questions_set_id == item.id + 2
      );
      const questions = questionsList?.filter((e) => e.topic_id == item.id);
      if (setProgress.length > 0) {
        const index = questions.findIndex(
          (obj) => obj.id == setProgress[0].last_seen_question_id
        );

        if (menu.free_model == 1) {
          navigate(`/studyquestions/question`, {
            state: {
              set_id: item?.id + 2,
              source: "study_menu",
              questions: questions.slice(0, item?.num_questions),
              lastIndex:
                index > item?.num_questions ? 0 : index == -1 ? 0 : index,
            },
          });
        } else {
          navigate(`/studyquestions/question`, {
            state: {
              set_id: item?.id + 2,
              source: "study_menu",
              questions: questions,
              lastIndex: index == -1 ? 0 : index,
            },
          });
        }
      }
    }
  }

  useEffect(() => {
    STUDY_QUESTION_MENU = GET_STUDY_QUESTION_MENU(selectedCertificate);
  }, [selectedCertificate]);

  // Card animations
  const cardVariants = {
    hover: {
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = (item) => {
    return currentTheme === 'light' ? theme?.icon_bg?.study_light : theme?.icon_bg?.study_dark;
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;

    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      borderLeft: `4px solid ${iconBg || (currentTheme === 'light' ? theme?.icon_bg?.study_light : theme?.icon_bg?.study_dark)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light'
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  // Helper function to get hover colors
  const getHoverColor = () => {
    return currentTheme === 'light'
      ? theme?.icon_bg?.study_light
      : theme?.icon_bg?.study_dark;
  };

  // Helper function to choose icon
  const getIcon = (item) => {
    if (item.key === "bookmark") return faBookmark;
    if (item.key === "by_topic" || item.key === "by_topic_free_model") return faBook;
    return faList;
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={() => navigate("/home")}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          {STRING?.study_questions_title}
        </h1>
      </div>

      {/* Categories Section */}
      <div className="grid grid-cols-1 gap-4 mb-8">
        {STUDY_QUESTION_MENU?.map((ele, idx) => {
          const isSelected = selectedMenu.includes(ele.title);

          if (ele.key === "bookmark") {
            const menu_length = ele.menu.length;
            ele.menu = [
              {
                id: menu_length + 1,
                domain_name: "All Bookmarks",
                requires_subscription: false,
              },
              ...ele.menu,
            ];
          }

          const iconBg = getIconBg();

          return (
            <motion.div
              key={idx + 1}
              className="bg-white dark:bg-gray-100 rounded-xl overflow-hidden shadow-sm"
              whileHover="hover"
              variants={cardVariants}
            >
              <div
                className="cursor-pointer"
                style={getCardBackground(iconBg)}
              >
                <div
                  className="p-4"
                  onClick={() => {
                    if (ele?.menu) {
                      if (isSelected) {
                        let selected = [...selectedMenu];
                        selected = selected.filter(
                          (menu) => menu != ele?.title
                        );
                        setSelectedMenu(selected);
                      } else {
                        let selected = [...selectedMenu];
                        selected.push(ele?.title);
                        setSelectedMenu(selected);
                      }
                    } else {
                      onPressItem(ele, idx);
                    }
                  }}
                >
                  <div className="flex items-center">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center mr-4"
                      style={{ backgroundColor: iconBg }}
                    >
                      <FontAwesomeIcon
                        icon={getIcon(ele)}
                        className="text-white text-xl"
                      />
                    </div>
                    <div className="flex-1">
                      <h2
                        className="text-lg font-medium"
                        style={{ color: getThemeTextColor(theme, currentTheme) }}
                      >
                        {ele?.title}
                      </h2>
                    </div>
                    {ele?.menu && (
                      <div className="ml-2">
                        <FontAwesomeIcon
                          icon={isSelected ? faChevronUp : faChevronDown}
                          style={{ color: getTextColor() }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Sub-items section */}
                {isSelected && ele?.menu && (
                  <div className="border-t border-gray-200 dark:border-gray-600">
                    {ele?.menu?.map((subElement, idx) => {
                      const no_of_que = getQuestionCount(ele, subElement);

                      return (
                        <div
                          key={subElement?.id}
                          className="p-4 border-b border-gray-100 dark:border-gray-700 hover:bg-opacity-50 cursor-pointer hover:bg-gray-500 dark:hover:bg-gray-500"
                          // onClick={() => {
                          //   if (ele.key === "bookmark") {
                          //     onPressBookmarkTopic(subElement, ele);
                          //   } else {
                          //     onPressTopic(subElement, ele);
                          //   }
                          // }}
                          onClick={() => {
                            const questionCount = ele?.free_model == 1 && subElement?.num_questions
                              ? subElement?.num_questions
                              : no_of_que;
                          
                            if (questionCount === 0 && ele.key === "bookmark") {
                              setShowInfoPopup(true);
                              return;
                            }
                          
                            if (ele.key === "bookmark") {
                              onPressBookmarkTopic(subElement, ele);
                            } else {
                              onPressTopic(subElement, ele);
                            }
                          }}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <h3
                                className="text-base font-medium"
                                style={{ color: getTextColor() }}
                              >
                                {subElement?.domain_name}
                              </h3>
                              {subElement?.content && (
                                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                  {subElement?.content}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center">
                              <span
                                className="text-sm px-3 py-1 rounded-full"
                                style={{
                                  backgroundColor: currentTheme === 'light'
                                    ? 'rgba(0,0,0,0.1)'
                                    : 'rgba(255,255,255,0.1)',
                                  color: getTextColor()
                                }}
                              >
                                {ele?.free_model == 1 && subElement?.num_questions
                                  ? subElement?.num_questions
                                  : no_of_que} Questions
                              </span>


                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>

      {showInfoPopup && (
        <InfoPopup
          title="No Bookmarks Found"
          message="There are no bookmarked questions in this topic."
          onClose={() => setShowInfoPopup(false)}
        />
      )}


      {/* Popups */}
      {isProgressQuestion && (
        <BookMarkPopup
          title={STRINGS.study_questions}
          message={STRINGS.flashcard_message}
          cancelText={STRINGS?.cancel}
          options={[STRINGS.start_from_beginning, STRINGS.resume_from_stopped]}
          onCancel={() => {
            setProgressQuestion(false);
            setSelectedTopic(null);
            setSelectedMainMenu(null);
          }}
          onPressOptions={async (index) => {
            setProgressQuestion(false);
            if (index === 0) {
              setSelectedTopic(null);
              setSelectedMainMenu(null);
              onAction(index);
            } else if (index === 1) {
              setSelectedTopic(null);
              setSelectedMainMenu(null);
              onAction(index);
            }
          }}
        />
      )}

      {isProgressProgressBookmark && (
        <BookMarkPopup
          title={STRINGS.study_questions}
          message={STRINGS.flashcard_message}
          cancelText={STRINGS?.cancel}
          options={[STRINGS.start_from_beginning, STRINGS.resume_from_stopped]}
          onCancel={() => {
            setProgressQuestion(false);
            setSelectedTopic(null);
            setSelectedBookmarkTopic(null)
            setProgressBookmark(false);
          }}
          onPressOptions={async (index) => {
            setProgressBookmark(false);
            if (index === 0) {
              setSelectedTopicBookmark(null);
              setSelectedBookmarkTopic(null)
              onActionBookmark(index);
            } else if (index === 1) {
              setSelectedTopicBookmark(null);
              setSelectedBookmarkTopic(null)
              onActionBookmark(index);
            }
          }}
        />
      )}
    </div>
  );
};

export default StudyQuestion;